import React from 'react';
import { Product, ProductCardStyle } from '../../types';
import { CardClassic } from './cards/CardClassic';
import { CardOverlay } from './cards/CardOverlay';
import { CardMinimal } from './cards/CardMinimal';
import { CardBrutal } from './cards/CardBrutal';
import { CardFloat } from './cards/CardFloat';

interface ProductCardProps {
  product: Product & { boostAmount?: number };
  onAddToCart: (product: Product) => void;
  cardStyle?: ProductCardStyle;
}

export const ProductCard: React.FC<ProductCardProps> = ({ product, onAddToCart, cardStyle = 'classic' }) => {
  
  switch (cardStyle) {
      case 'overlay':
          return <CardOverlay product={product} onAddToCart={onAddToCart} />;
      case 'minimal':
          return <CardMinimal product={product} onAddToCart={onAddToCart} />;
      case 'brutal':
          return <CardBrutal product={product} onAddToCart={onAddToCart} />;
      case 'float':
          return <CardFloat product={product} onAddToCart={onAddToCart} />;
      case 'classic':
      default:
          return <CardClassic product={product} onAddToCart={onAddToCart} />;
  }
};